import { ColorEnum } from '@/constants/color'
import Button from '@/features/ui/buttons/components/Button'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface BottomActionsProps {
    compact?: boolean
    onCancel: () => void
    onConfirm: () => void
    onSearchNewCustomer: () => void
    searchNewCustomerDisabled: boolean
}

const BottomActions: FC<BottomActionsProps> = ({
    compact = false,
    onCancel,
    onConfirm,
    onSearchNewCustomer,
    searchNewCustomerDisabled,
}) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            {!compact ? (
                <View style={styles.leftHalf}>
                    <Button
                        color="primary"
                        disabled={searchNewCustomerDisabled}
                        onPress={onSearchNewCustomer}
                        size="big"
                        style={styles.fullWidthButton}
                    >
                        {t('pos.customerLookupModal.actions.searchNewCustomer')}
                    </Button>
                </View>
            ) : null}
            <View style={[styles.rightHalf, compact && styles.rightHalfCompact]}>
                <Button
                    color="secondary"
                    onPress={onCancel}
                    size="big"
                    style={[styles.halfWidthButton, compact && styles.halfWidthButtonCompact]}
                    type="outline"
                >
                    {t('pos.customerLookupModal.actions.cancel')}
                </Button>
                <Button
                    color="secondary"
                    onPress={onConfirm}
                    size="big"
                    style={[styles.halfWidthButton, compact && styles.halfWidthButtonCompact]}
                >
                    {t('pos.customerLookupModal.actions.save')}
                </Button>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: ColorEnum.VIOLET_100,
        flexDirection: 'row',
        padding: 16,
    },
    leftHalf: {
        flex: 1,
        paddingRight: 8,
    },
    rightHalf: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'row',
        gap: 16,
        justifyContent: 'center',
        paddingLeft: 8,
    },
    rightHalfCompact: {
        flex: 1,
        paddingLeft: 0,
    },
    fullWidthButton: {
        borderRadius: 8,
        justifyContent: 'center',
        width: '100%',
    },
    halfWidthButton: {
        borderRadius: 8,
        flex: 1,
        justifyContent: 'center',
    },
    halfWidthButtonCompact: {
        minWidth: 0,
    },
})

export default BottomActions
